import "../../assets/styles/yaongcon.scss";
import PointImg from "../../assets/images/img_point.png";
import Starbucks from "../../assets/images/brand_logos/starbucks.png";
import BHC from "../../assets/images/brand_logos/bhc.png";
import AngelInUs from "../../assets/images/brand_logos/angel-in-us.jpg";
import ParisBaguette from "../../assets/images/brand_logos/PB_logo.png";
import Lotteria from "../../assets/images/brand_logos/lotteria.jpg";
import Kyochon from "../../assets/images/brand_logos/kyochon.jpg";
import CU from "../../assets/images/brand_logos/cu_logo.jpg";
import GS25 from "../../assets/images/brand_logos/gs25.jpg";
import Shinsegae from "../../assets/images/brand_logos/신세계_로고.png";
import GiftLetter from "../../assets/images/brand_logos/gift_letter.png";
import NaverPay from "../../assets/images/brand_logos/npay.png";
import {ReactComponent as InfoIcon} from "../../assets/icons/vuesax/bold/info-circle.svg";
import {useLocation, useNavigate} from "react-router";
import {ReactComponent as ArrowIcon} from "../../assets/icons/arrow_right.svg";
import {useState, useContext, useEffect} from "react";
import {AuthContext} from "../../context/AuthContext";
import {AlertDialog} from "../../components/common/Modal";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import {useScript, useRunTimeEnvironment} from "../../utils/hooks";
import useRequirePhoneCert from "../../hooks/useRequirePhoneCert";
import PhoneCertGate from "../../components/verification-v2/PhoneCertGate";

export default function YaongconPage() {

  const navigate = useNavigate();
  const [showInfo, setShowInfo] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("전체");
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { state } = useLocation();
  const RTE = useRunTimeEnvironment();

  const {
    ready: phoneCertReady,
    needsCert,
    checking: phoneCertChecking,
    goToVerification,
  } = useRequirePhoneCert({
    enabled: true,
    mode: 'gate',
    redirectTo: '/coupons',
    redirectState: state,
  });

  // 게이트만 표시: 목록·프로필은 인증 여부와 무관하게 로드 (피그마 오버레이 UX)
  const canLoadList = Boolean(accessToken) && !phoneCertChecking;

  const { data: brand } = useSWRImmutable(canLoadList && `${API_SERVER_DOMAIN}/yaongcon/brand`, url => fetch(url).then(res => res.json()));
  const { data: profile } = useSWR(canLoadList && accessToken && [`${API_SERVER_DOMAIN}/user/profile/info`, accessToken], fetchWithToken);
  const { data: coupon } = useSWR(canLoadList && accessToken && [`${API_SERVER_DOMAIN}/user/coupon`, accessToken], fetchWithToken);
  const { data: limit } = useSWR(canLoadList && accessToken && [`${API_SERVER_DOMAIN}/yaongcon/purchase`, accessToken], fetchWithToken);

  const brandLogo = {
    "기프트레터 상품권": GiftLetter,
    "GS25": GS25,
    "GS25 금액권": GS25,
    "CU": CU,
    "네이버페이": NaverPay,
    "롯데리아": Lotteria,
    "BHC": BHC,
    "교촌치킨": Kyochon,
    "엔제리너스(GRS)": AngelInUs,
    "파리바게뜨": ParisBaguette,
    "신세계백화점": Shinsegae,
    "스타벅스": Starbucks,
  };

  function onClickInfo(e) {
    setShowInfo(true);
    e.stopPropagation();
  }

  function goToMain() {
    navigate("/playground", { replace: true });
  }

  async function getProductList(brandName = "") {
    const response = await fetch(`${API_SERVER_DOMAIN}/yaongcon/goods/list?brandName=${encodeURIComponent(brandName)}`, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    const jsonData = await response.json();

    setSelectedBrand(brandName ? brandName : "전체");
    if (jsonData.result !== "ok") {
      setProducts([]);
      return;
    }

    const list = [];
    jsonData.infos.forEach(info => {
      list.push({
        goodsId: info.goodsId,
        place: info.brandName,
        goodsName: info.goodsName,
        goodsPrice: info.price,
        goodsImgUrl: info.imgUrl,
      });
    });

    setProducts(list);
  }

  useScript(`${process.env.PUBLIC_URL}/flutter/flutter_script.js`);
  useEffect(() => {
    if (!canLoadList) return;

    const initialBrand = typeof state?.selectedBrand === 'string' ? state.selectedBrand : '';
    if (initialBrand) {
      getProductList(initialBrand);
    } else {
      getProductList();
    }

    if (state?.purchased && RTE === "APP") {
      window.flutter_inappwebview.callHandler("show_interstitial_purchase");
    }
  }, [canLoadList]);

  if (phoneCertChecking || !canLoadList) return null;
  if (!brand || brand?.result !== "ok") return;
  if (!profile || profile?.result !== "ok") return;
  if (!coupon || coupon?.result !== "ok") return;
  if (!limit) return;

  if (limit.result === "fail") {
    return (
      <AlertDialog
        open={true}
        title="안내"
        text={limit.message ?? "야옹콘 이용이 일시 중단되었습니다. 빠른 시일 내에 다시 찾아뵙겠습니다."}
        buttonText="확인"
        onClose={goToMain}
        onCancel={goToMain}
        onOk={goToMain}
      />
    );
  }

  return (
    <section className="yaongcon-page" onClick={() => setShowInfo(false)}>
      <PhoneCertGate
        open={needsCert}
        onVerify={goToVerification}
        onClose={() => navigate('/playground', { replace: true })}
      />
      <header className="header-shadow">
        <h1>
          야옹콘
          <span>오늘 남은 구매 현황 ({limit.purchaseCount}/3)</span>
        </h1>
        <img src={PointImg} alt={"points"} width={24}/>
        <span>{profile.info.point.toLocaleString()}</span>
        <svg onClick={() => navigate("/notifications")} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M7.22678 3.22703C8.49265 1.96116 10.2095 1.25 11.9997 1.25C13.79 1.25 15.5068 1.96116 16.7727 3.22703C18.0386 4.4929 18.7497 6.20979 18.7497 8C18.7497 10.9571 19.4936 12.9344 20.2869 14.2092L20.2958 14.2235C20.6555 14.8016 20.9362 15.2528 21.1246 15.5795C21.2189 15.7431 21.301 15.8943 21.3602 16.0248C21.3898 16.09 21.4208 16.1653 21.4444 16.2446C21.4645 16.3119 21.4988 16.4441 21.4859 16.6019C21.4757 16.7273 21.4514 16.9183 21.3433 17.1129C21.2352 17.3075 21.0858 17.429 20.9848 17.5039C20.7858 17.6516 20.5508 17.6868 20.459 17.7004C20.3251 17.7202 20.1685 17.7307 20.0025 17.7371C19.6722 17.75 19.2121 17.75 18.6301 17.75H18.6109H5.3886H5.36941C4.78744 17.75 4.32732 17.75 3.99701 17.7371C3.83099 17.7307 3.67438 17.7202 3.54047 17.7004C3.44871 17.6868 3.21369 17.6516 3.01469 17.5039C2.91365 17.429 2.76426 17.3075 2.65617 17.1129C2.54809 16.9183 2.52382 16.7273 2.51357 16.6019C2.50066 16.4441 2.53503 16.3119 2.55505 16.2446C2.57867 16.1653 2.60965 16.09 2.63925 16.0248C2.69853 15.8943 2.78063 15.7431 2.87494 15.5795C3.06323 15.2528 3.3439 14.8017 3.70353 14.2238L3.71263 14.2092C4.50586 12.9344 5.24975 10.9571 5.24975 8C5.24975 6.20979 5.96091 4.4929 7.22678 3.22703ZM11.9997 2.75C10.6074 2.75 9.272 3.30312 8.28744 4.28769C7.30287 5.27226 6.74975 6.60761 6.74975 8C6.74975 11.2233 5.93457 13.4775 4.9862 15.0016C4.6492 15.5432 4.39777 15.9475 4.2241 16.2434C4.50893 16.2499 4.88935 16.25 5.3886 16.25H18.6109C19.1101 16.25 19.4906 16.2499 19.7754 16.2434C19.6017 15.9475 19.3503 15.5432 19.0133 15.0017C18.0649 13.4775 17.2497 11.2233 17.2497 8C17.2497 6.60761 16.6966 5.27225 15.7121 4.28769C14.7275 3.30312 13.3921 2.75 11.9997 2.75ZM20.2577 16.2136C20.2683 16.2105 20.2744 16.2094 20.2749 16.2096C20.2753 16.2098 20.27 16.2113 20.2577 16.2136ZM3.72461 16.2096C3.72504 16.2094 3.73118 16.2105 3.74176 16.2136C3.72947 16.2113 3.72418 16.2098 3.72461 16.2096ZM8.79162 20.5037C9.06572 20.1931 9.53967 20.1636 9.85022 20.4377C10.4236 20.9438 11.175 21.25 11.9997 21.25C12.8245 21.25 13.5759 20.9438 14.1493 20.4377C14.4598 20.1636 14.9338 20.1931 15.2079 20.5037C15.482 20.8143 15.4524 21.2882 15.1419 21.5623C14.305 22.301 13.2039 22.75 11.9997 22.75C10.7956 22.75 9.69451 22.301 8.85762 21.5623C8.54707 21.2882 8.51752 20.8143 8.79162 20.5037Z" fill="#222222"/>
          <rect x="10" y="-2" width="12" height="12" fill="#FFFFFF" visibility={profile.showRedDot ? "visible" : "hidden"} />
          <rect x="12" width="8" height="8" rx="4" fill="#F6475F" visibility={profile.showRedDot ? "visible" : "hidden"} />
          {/* <path fillRule="evenodd" clipRule="evenodd" d="M17.3452 9.84861C17.5869 12.1101 18.2578 13.7875 19.0133 15.0016C19.3503 15.5432 19.6017 15.9475 19.7754 16.2434C19.4906 16.2499 19.1101 16.25 18.6109 16.25H5.3886C4.88935 16.25 4.50893 16.2499 4.2241 16.2434C4.39777 15.9475 4.6492 15.5432 4.9862 15.0016C5.93457 13.4775 6.74975 11.2233 6.74975 7.99999C6.74975 6.60761 7.30287 5.27225 8.28744 4.28768C8.79876 3.77636 9.4047 3.3814 10.0641 3.11986C10.1535 2.51158 10.3342 1.93299 10.5918 1.39844C9.32682 1.66825 8.15543 2.29837 7.22678 3.22702C5.96091 4.49289 5.24975 6.20978 5.24975 7.99999C5.24975 10.957 4.50586 12.9344 3.71263 14.2092L3.70353 14.2238L3.70352 14.2238C3.34389 14.8018 3.06323 15.2528 2.87494 15.5795C2.78063 15.7431 2.69853 15.8943 2.63925 16.0248C2.60965 16.09 2.57867 16.1653 2.55505 16.2446C2.53503 16.3119 2.50066 16.4441 2.51357 16.6019C2.52382 16.7273 2.54809 16.9183 2.65617 17.1129C2.76426 17.3074 2.91365 17.429 3.01469 17.5039C3.21369 17.6516 3.44871 17.6868 3.54047 17.7004C3.67438 17.7202 3.83099 17.7307 3.99701 17.7371C4.32732 17.75 4.78744 17.75 5.36941 17.75H5.3886H18.6109H18.6301C19.2121 17.75 19.6722 17.75 20.0025 17.7371C20.1685 17.7307 20.3251 17.7202 20.459 17.7004C20.5508 17.6868 20.7858 17.6516 20.9848 17.5039C21.0858 17.429 21.2352 17.3074 21.3433 17.1129C21.4514 16.9183 21.4757 16.7273 21.4859 16.6019C21.4988 16.4441 21.4645 16.3119 21.4444 16.2446C21.4208 16.1653 21.3898 16.09 21.3602 16.0248C21.301 15.8943 21.2189 15.7431 21.1246 15.5795C20.9363 15.2528 20.6556 14.8018 20.296 14.2238L20.2958 14.2235L20.2869 14.2092C19.6168 13.1323 18.9819 11.5541 18.8009 9.30746C18.3471 9.54749 17.8587 9.73099 17.3452 9.84861ZM20.2577 16.2136C20.2683 16.2105 20.2744 16.2094 20.2749 16.2096C20.2753 16.2098 20.27 16.2113 20.2577 16.2136ZM3.72461 16.2096C3.72504 16.2094 3.73118 16.2105 3.74176 16.2136C3.72947 16.2113 3.72418 16.2098 3.72461 16.2096ZM9.85022 20.4377C9.53967 20.1636 9.06572 20.1931 8.79162 20.5037C8.51752 20.8142 8.54707 21.2882 8.85762 21.5623C9.69451 22.301 10.7956 22.75 11.9997 22.75C13.2039 22.75 14.305 22.301 15.1419 21.5623C15.4524 21.2882 15.482 20.8142 15.2079 20.5037C14.9338 20.1931 14.4598 20.1636 14.1493 20.4377C13.5759 20.9438 12.8245 21.25 11.9997 21.25C11.175 21.25 10.4236 20.9438 9.85022 20.4377Z" fill="#222222"/> */}
        </svg>
      </header>

      <div className="my-coupon-btn">
        <span>나의 쿠폰</span>
        <InfoIcon onClick={onClickInfo} height={18}/>
        <span>{coupon.infos.filter(c => c.status === "AVAILABLE").length}</span>
        <ArrowIcon height={16} onClick={() => navigate("/user/coupons", {state: {nickname: profile.info.nickname}})}/>
        {showInfo &&
          <div className="coupon-info-message">
            <p>내가 가진 쿠폰이에요. 오른쪽 숫자를 눌러 쿠폰을 확인해보세요!</p>
          </div>
        }
      </div>
      
      <h2>인기 브랜드</h2>
      <div className="brand-list">
        <div role="button" onClick={() => getProductList()}>
          <div className={`all-brand-img ${selectedBrand === "전체" && "selected"}`}>ALL</div>
          <span>전체</span>
        </div>
        {brand.infos.map((name, idx) => (
          <div key={"brand"+idx} role="button" onClick={() => getProductList(name)}>
            <img src={brandLogo[name]} alt={name} width={72} height={72} className={selectedBrand === name ? "selected" : ""} />
            <span>{name}</span>
          </div>
        ))}
      </div>

      <h2>{selectedBrand}</h2>
      <div className="brand-coupon-list">
        {products.map(product => (
          <div key={product.goodsId} onClick={() => navigate("/coupons/detail", {state: {...product, type: "야옹콘", purchaseCount: limit.purchaseCount}})}>
            <img src={product.goodsImgUrl} alt="상품 이미지"/>
            <div>
              <span style={{fontSize: 12}}>[{product.place}]</span>
              <span style={{margin: '4px 0 12px'}}>{product.goodsName}</span>
              <div>
                {/* <img src={YaCoinIcon} alt="ya_coin" className="h-4 w-4 object-contain" /> */}
                <img src={PointImg} alt={"points"} height={24}/>
                <span style={{fontSize: 18}}>{product.goodsPrice.toLocaleString()}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}